module.exports = __webpack_public_path__ + "img/jyh-qrcode.a14465a8.jpg";